import { Link } from 'react-router-dom';
import { CaseStudy } from '../content/caseStudies';
import './CaseStudyCard.css';

interface CaseStudyCardProps {
  study: CaseStudy;
}

/**
 * A case study card. Renders as a link so the whole card is clickable but
 * remains semantically meaningful. The thumbnail accepts a real image src or
 * falls back to a gradient placeholder defined in content.
 */
export default function CaseStudyCard({ study }: CaseStudyCardProps) {
  const [from, to] = study.thumbnail.gradient;
  return (
    <Link
      to={`/case-studies/${study.slug}`}
      className="case-card"
      aria-label={`Read case study: ${study.title}`}
    >
      <div
        className="case-card__thumb"
        role="img"
        aria-label={study.thumbnail.alt}
        style={
          study.thumbnail.src
            ? {
                backgroundImage: `url(${study.thumbnail.src})`,
                backgroundPosition: study.thumbnail.position ?? 'center',
              }
            : { backgroundImage: `linear-gradient(135deg, ${from}, ${to})` }
        }
      >
        
      </div>
      <div className="case-card__body">
        <ul className="case-card__tags" aria-label="Project tags">
          {study.tags.map((t) => (
            <li key={t} className="case-card__tag">
              {t}
            </li>
          ))}
        </ul>
        <h3 className="case-card__title">{study.title}</h3>
        <p className="case-card__summary">{study.summary}</p>
        <span className="case-card__cta" aria-hidden="true">
          Read case study →
        </span>
      </div>
    </Link>
  );
}
